import React, { useCallback, useState } from "react";
import { Modal } from "../../components";
import { deleteDocsAPI } from "../../common/services";
import { useToaster } from "../../common/contexts/toast";
import { errorMessageOf, failureMessageOf } from "../../utils";
import { isOutdatedSelectionError, OUTDATED_SELECTION_MESSAGE } from "./utils";

const DeleteDocsModal = ({ visible, selection, count = 0, onClose, onDeleted, onSelectionOutdated }) => {
    const { showToaster } = useToaster();
    const [deleting, setDeleting] = useState(false);

    const many = count > 1;

    const confirmDelete = useCallback(async () => {
        if (!selection || deleting) return;
        setDeleting(true);
        try {
            const { data } = await deleteDocsAPI(selection);
            const failedCount = data?.failed?.length || 0;
            const deletedCount = data?.deleted || 0;

            if (failedCount) {
                showToaster && showToaster(
                    "docs-delete-error",
                    failureMessageOf(data.failed, `Deleted ${deletedCount} file(s), couldn't delete ${failedCount}.`),
                    false
                );
            } else {
                showToaster && showToaster(
                    "docs-delete-success",
                    many ? `Deleted ${deletedCount} files.` : "The file has been deleted.",
                    true
                );
            }

            onClose && onClose();
            onDeleted && onDeleted();
        } catch (error) {
            const isOutdated = isOutdatedSelectionError(error);
            showToaster && showToaster("docs-delete-error", errorMessageOf(error, isOutdated ? OUTDATED_SELECTION_MESSAGE : "Couldn't delete the file(s)."), false);
            if (isOutdated) {
                onClose && onClose();
                onSelectionOutdated && onSelectionOutdated();
            }
        } finally {
            setDeleting(false);
        }
    }, [selection, many, deleting, showToaster, onClose, onDeleted, onSelectionOutdated]);

    return (
        <Modal
            visible={visible}
            type="surprised"
            size="large"
            title={many ? "Delete selected files" : "Delete file"}
            extraMessage={
                <>
                    You are about to delete {many ? `the ${count} selected files` : "the file"}.
                    <br /><br />
                    Deleting a Base file (“Parent”) will delete its Annexes files.
                    <br /><br />
                    These files will be removed from the DOCS portal and relevant projects.
                </>
            }
            closable={!deleting}
            onClose={() => !deleting && onClose && onClose()}
            onClickCancel={() => !deleting && onClose && onClose()}
            onClickConfirm={confirmDelete}
            cancelButtonName="CANCEL"
            cancelButtonDisable={deleting}
            confirmButtonName="DELETE"
            confirmButtonDisable={deleting}
            confirmButtonLoading={deleting}
            modalClass="delete-docs-modal"
        />
    );
};

export default DeleteDocsModal;
